export default {
	name: 'zh-CN',
	to: {
		common: {
			confirm: '确定',
			cancel: '取消',
			clear: '清除',
			more: '更多',
			index: '序号',
			unlimit: '不限',
			select: '选择',
			selectAll: '全选',
			inverse: '反选',
			originalValue: '原始值：{0}',
			data: '选项1,选项2,选项3',
			noData: '暂无数据',
			noDataDesc: '请先获取到数据',
			noMatch: '暂无数据',
			now: '此刻',
			placeholder: {
				select: '请选择',
				input: '请填写'
			}
		},
		validate: {
			desc: {
				en: '英文',
				enLower: '小写英文字母',
				enUpper: '大写英文字母',
				enNone: '字母',
				cn: '中文',
				number: '数字',
				integer: '整数',
				integerP: '正整数',
				integerN: '负整数',
				nature: '自然数',
				date: '日期',
				time: '24 小时格式时间',
				time12: '12 小时格式时间',
				money: '金额',
				ip: 'IPV4 地址格式',
				ipV6: 'IPV6 地址格式',
				password: '密码',
				username: '用户名',
				name: '姓名',
				nameCn: '中文姓名',
				nameEn: '英文姓名',
				email: '邮件地址',
				qq: 'QQ 号码',
				wechat: '微信号',
				web: '网址信息',
				uscc: '统一社会信用代码',
				bank: '银行卡号',
				phone: '手机号码',
				telphone: '座机号码',
				id: '身份证号码',
				passport: '护照号码',
				mac: 'mac 地址'
			},
			remark: {
				password: '包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符',
				username: '4到16位，仅支持字母，数字，下划线，减号'
			},
			tip: {
				common: '{0}格式不正确，请填写正确的{1}',
				customRemark: '{0}格式不正确{1}',
				custom: '{0}格式不正确{1}',
				required: '{0}不能为空',
				requiredRemark: '{0}不能为空'
			}
		},
		input: {
			inputError: '输入内容有误',
			required: '该项为必填项'
		},
		calendar: {
			year: {
				suffix: '年'
			},
			month: {
				suffix: '月',
				m1: '1月',
				m2: '2月',
				m3: '3月',
				m4: '4月',
				m5: '5月',
				m6: '6月',
				m7: '7月',
				m8: '8月',
				m9: '9月',
				m10: '10月',
				m11: '11月',
				m12: '12月'
			},
			week: {
				w0: '日',
				w1: '一',
				w2: '二',
				w3: '三',
				w4: '四',
				w5: '五',
				w6: '六'
			},
			day: {
				holiday: '假'
			},
			time: {
				title: '选择时间',
				hPlaceholder: 'H',
				mPlaceholder: 'M',
				sPlaceholder: 'S'
			},
			tip: {
				error: {
					selectDate: '请选择日期'
				}
			}
		},
		ellipsis: {
			unfold: '收起',
			fold: '全文'
		},
		guider: {
			dontShowAgain: '不再显示',
			restart: '再来一遍',
			finish: '完成',
			skip: '跳过',
			next: '下一步'
		},
		page: {
			total: '共 {0} 条',
			pageCount: '共 {0} 页',
			pageSize: '{0}条/页',
			go: '跳转',
			prevPage: '上一页',
			nextPage: '下一页'
		},
		pic: {
			viewer: {
				full: '全屏',
				restore: '原图'
			},
			tip: {
				error: {
					load: '加载失败'
				}
			}
		},
		scroll: {
			tip: {
				error: {
					paramType: '{0} 参数类型错误'
				}
			}
		},
		segment: {
			tip: {
				error: {
					res: '{0}获取失败{1}',
					api: '{0}获取失败：接口调用错误'
				}
			}
		},
		switch: {
			changed: '此处已修改'
		},
		select: {
			noData: '暂无数据',
			noMatch: '无匹配项',
			filter: '筛选',
			selectError: '选择有误',
			required: '不能为空',
			input: {
				allSelected: '已全选'
			},
			float: {
				title: '选择{0}',
				titlePlaceholder: '请选择'
			},
			tip: {
				error: {
					res: '{0}获取失败',
					api: '{0}获取失败：接口调用错误',
					repetition: '您正在添加的选项已被选定，请修改后重试'
				}
			}
		},
		cascader: {
			placeholder: '请选择',
			noData: '暂无数据',
			inputError: '选择内容有误',
			required: '该项为必填项'
		},
		export: {
			button: '导出',
			input: {
				placeholder: '请输入文件名'
			},
			tip: {
				ready: '导出设置完成，请点击导出',
				start: '开始导出 {0}',
				success: '导出完成',
				error: {
					filename: '请输入或修改要导出的文件名'
				}
			}
		},
		import: {
			button: '导入',
			template: '模板下载',
			tip: {
				submit: '开始上传：{0}',
				placeholder: '请选择要导入的文件',
				error: {
					type: '非法的文件类型！',
					size: '文件大小超过限制！'
				}
			}
		},
		upload: {
			button: '上传',
			tip: {
				selected: '已选择{0}个文件',
				error: {
					selected: '{0}，其中{1}个不符合要求',
					format: '文件格式不正确，请上传{0}格式文件',
					size: '文件大小超过限制：{0}',
					count: '最多只能上传{0}个文件'
				}
			}
		},
		table: {
			emptyText: '暂无数据'
		}
	}
}
